// extracted by mini-css-extract-plugin
export default {"chart1":"Chart_chart1__F6Zec"};